export const updateGeoPointCustom = /* GraphQL */ `
  mutation UpdateGeoPoint(
    $input: UpdateGeoPointInput!
    $condition: ModelGeoPointConditionInput
  ) {
    updateGeoPoint(input: $input, condition: $condition) {
      id
      name
      lat
      lng
      elevation
      geojson
      imageUrl
      icon
      client
      value {
        value
        currency
        __typename
      }
      description
      assetGroupId
      organizationId
      displayedChannels
      # precipCurveId
      # precipCurve {
      #   id
      #   # type
      #   name
      #   description
      #   xUnit
      #   yUnit
      #   createdAt
      #   updatedAt
      #   owner
      #   __typename
      # }
      # windCurveId
      # windCurve {
      #   id
      #   name
      #   description
      #   xUnit
      #   yUnit
      #   curveData {
      #     x
      #     y
      #   }
      #   createdAt
      #   updatedAt
      #   owner
      #   __typename
      # }
      # solarCurveId
      # solarCurve { Craig Upddate this
      #   id
      #   type
      #   name
      #   description
      #   xUnit
      #   yUnit
      #   createdAt
      #   updatedAt
      #   owner
      #   __typename
      # }
      createdAt
      updatedAt
      userGeoPointsId
      owner
      __typename
    }
  }
`;

export const createGeoPointCustom = /* GraphQL */ `
  mutation CreateGeoPoint(
    $input: CreateGeoPointInput!
    $condition: ModelGeoPointConditionInput
  ) {
    createGeoPoint(input: $input, condition: $condition) {
      id
      name
      lat
      lng
      elevation
      geojson
      imageUrl
      icon
      client
      value {
        value
        currency
        __typename
      }
      description
      processedModels {
        nextToken
        __typename
      }
      assetGroupId
      precipCurveId
      organizationId
      displayedChannels
      # precipCurve {
      #   id
      #   name
      #   description
      #   xUnit
      #   yUnit
      #   createdAt
      #   updatedAt
      #   owner
      #   __typename
      # }
      windCurveId
      # windCurve {
      #   id
      #   name
      #   description
      #   xUnit
      #   yUnit
      #   createdAt
      #   updatedAt
      #   owner
      #   __typename
      # }
      solarCurveId
      # solarCurve {
      #   id
      #   name
      #   description
      #   xUnit
      #   yUnit
      #   dcCap
      #   acCap
      #   panelEfficiency
      #   thermalLoss
      #   minIrradiance
      #   trackingType
      #   arrayTilt
      #   arrayAzimuth
      #   maxTilt
      #   groundCoverRatio
      #   createdAt
      #   updatedAt
      #   owner
      #   __typename
      # }
      createdAt
      updatedAt
      userGeoPointsId
      owner
      __typename
    }
  }
`;


export const deleteGeoPointCustom = /* GraphQL */ `
  mutation DeleteGeoPoint(
    $input: DeleteGeoPointInput!
    $condition: ModelGeoPointConditionInput
  ) {
    deleteGeoPoint(input: $input, condition: $condition) {
      id
      name
      elevation
      client
      description
      assetGroupId
      createdAt
      updatedAt
      userGeoPointsId
      owner
      __typename
    }
  }
`;

export const createUserOrganizationsCustom = /* GraphQL */ `
  mutation CreateUserOrganizations(
    $input: CreateUserOrganizationsInput!
    $condition: ModelUserOrganizationsConditionInput
  ) {
    createUserOrganizations(input: $input, condition: $condition) {
      id
      userID
      organizationId
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;

export const updateUserCustom = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      username
      email
      name
      profilePictureUrl
      cognitoIdentityId
      assetGroupCount
      assetCount
      termsAndConditionsReviewed
      termsAndConditionsLocation
      chatPrivacyPolicyAccepted
      chatPrivacyPolicyLocation
      termsAndConditionsAuditTrail
      privacyPolicyAuditTrail
      userConsent
      tourWelcomeShown
      tourChatCompleted
      tourGroupSeen
      tourAssetSeen
      tourOnboardingGuidanceSent
      preferredPersonaId
      createdAt
      updatedAt
    }
  }
`;

// Slim selection set — tour writes are frequent and only ever need the flags back.
export const updateUserTourFlagsCustom = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      tourWelcomeShown
      tourChatCompleted
      tourGroupSeen
      tourAssetSeen
      tourOnboardingGuidanceSent
    }
  }
`;

export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      username
      email
      name
      profilePictureUrl
      cognitoIdentityId
      termsAndConditionsReviewed
      termsAndConditionsLocation
      chatPrivacyPolicyAccepted
      chatPrivacyPolicyLocation
      termsAndConditionsAuditTrail
      privacyPolicyAuditTrail
      userConsent
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const createProcessedModelCustom = /* GraphQL */ `
  mutation CreateProcessedModel(
    $input: CreateProcessedModelInput!
    $condition: ModelProcessedModelConditionInput
  ) {
    createProcessedModel(input: $input, condition: $condition) {
      id
      assetId
      label
      description
      routeShort
      routeLong
      displayType
      modelType
      schema
      owner
      organizationId
      additionalDataPoints {
        id
        name
        parameterId
        source
        schema
        lookbackDays
        color
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const updateProcessedModelCustom = /* GraphQL */ `
  mutation UpdateProcessedModel(
    $input: UpdateProcessedModelInput!
    $condition: ModelProcessedModelConditionInput
  ) {
    updateProcessedModel(input: $input, condition: $condition) {
      id
      assetId
      label
      description
      routeShort
      routeLong
      displayType
      modelType
      schema
      owner
      organizationId
      additionalDataPoints {
        id
        name
        parameterId
        source
        schema
        lookbackDays
        color
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const createProcessedModelOutputParamCustom = /* GraphQL */ `
  mutation CreateProcessedModelOutputParam(
    $input: CreateProcessedModelOutputParamInput!
    $condition: ModelProcessedModelOutputParamConditionInput
  ) {
    createProcessedModelOutputParam(input: $input, condition: $condition) {
      id
      name
      unit
      description
      organizationId
      owner
      channels
      outputLocation
      parameterTypeId
      active
      schemaId
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const createProcessedModelSchemaCustom = /* GraphQL */ `
  mutation CreateProcessedModelSchema(
    $input: CreateProcessedModelSchemaInput!
    $condition: ModelProcessedModelSchemaConditionInput
  ) {
    createProcessedModelSchema(input: $input, condition: $condition) {
      id
      name
      description
      type
      schemaType
      version
      executionUrl
      schemaFields
      runSchedule
      isActive
      activeStatus
      owner
      organizationId
      s3BasePath
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const createUserPersonaCustom = /* GraphQL */ `
  mutation CreateUserPersona(
    $input: CreateUserPersonaInput!
    $condition: ModelUserPersonaConditionInput
  ) {
    createUserPersona(input: $input, condition: $condition) {
      id
      userId
      name
      selectedNeeds
      regions
      markets
      description
      summary
      completed
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;

// Simple DataSetRecord mutation without nested dataset field to avoid auth issues
export const createDataSetRecordSimple = /* GraphQL */ `
  mutation CreateDataSetRecord(
    $input: CreateDataSetRecordInput!
    $condition: ModelDataSetRecordConditionInput
  ) {
    createDataSetRecord(input: $input, condition: $condition) {
      id
      datasetId
      timeValue
      s3Path
      fileName
      uploadedAt
      fileSize
      compressedSize
      recordCount
      timeRange
      columns
      compressionType
      organizationId
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;